import { render, staticRenderFns } from "./RecordingButton.vue?vue&type=template&id=98664618"
import script from "./RecordingButton.vue?vue&type=script&lang=js"
export * from "./RecordingButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports